const openFilterHandler = () => {
  const filters = document.querySelectorAll('[data-filter]');

  if (!filters.length) return;

  filters.forEach((filter) => {
    const btn = filter.querySelector('[data-filter="button"]');
    if (!btn) return;

    btn.addEventListener('click', () => {
      filter.classList.toggle('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!filter.contains(e.target)) {
        filter.classList.remove('is-open');
      }
    });
  });
};

export {openFilterHandler};
